// installmentPaymentService.js - Service pour les paiements en plusieurs fois
import strapiClient from './strapi/config';

export const installmentPaymentService = {
    /**
     * Créer un plan de paiement échelonné
     * @param {Object} planData - Les données du plan de paiement
     * @param {Object} customerData - Les informations client
     */
    createInstallmentPlan: async (planData, customerData) => {
        try {
            console.log('🔄 Creating installment plan:', { planData, customerData });

            // ✅ VALIDATION ET MAPPING des données avant envoi
            const requestBody = {
                planType: planData.type || 'installment',
                installmentAmount: Number(planData.amount),
                totalInstallments: Number(planData.installments),
                totalAmount: planData.totalAmount ? Number(planData.totalAmount) : (Number(planData.amount) * Number(planData.installments)),
                productId: customerData.productId,
                customerInfo: {
                    firstName: customerData.firstName,
                    lastName: customerData.lastName,
                    email: customerData.email
                },
                metadata: customerData.metadata || {},
                ...(customerData.promoCodeId && { promoCodeId: customerData.promoCodeId })
            };

            // ✅ VALIDATION des données obligatoires
            if (!requestBody.installmentAmount || requestBody.installmentAmount <= 0) {
                throw new Error('Montant de la mensualité invalide');
            }
            
            if (!requestBody.totalInstallments || requestBody.totalInstallments <= 0) {
                throw new Error('Nombre de mensualités invalide');
            }
            
            if (!requestBody.customerInfo.email) {
                throw new Error('Email client requis');
            }
            
            if (!requestBody.productId) {
                throw new Error('ID produit requis');
            }

            console.log('📤 Données envoyées à Strapi:', requestBody);

            const response = await strapiClient.post('/api/payment/create-installment-plan', requestBody);

            console.log('✅ Installment plan created:', response.data);

            // La réponse contient déjà le clientSecret pour le premier paiement
            return {
                installmentPlanId: response.data.installmentPlanId,
                clientSecret: response.data.clientSecret,
                paymentIntentId: response.data.paymentIntentId,
                plan: response.data.plan
            };

        } catch (error) {
            console.error('💥 Erreur création plan échelonné:', error);
            console.error('Error details:', {
                status: error.response?.status,
                data: error.response?.data,
                message: error.message
            });
            
            // ✅ Messages d'erreur plus précis
            if (error.response?.status === 400) {
                const errorMsg = error.response.data?.message || error.response.data?.error?.message || 'Données de plan incomplètes';
                throw new Error(errorMsg);
            }
            
            throw new Error(
                error.response?.data?.error?.message || 
                error.response?.data?.message ||
                error.message ||
                'Erreur lors de la création du plan de paiement'
            );
        }
    },

    /**
     * Traiter un paiement échelonné (premier paiement) - OPTIONNEL
     * Cette méthode n'est plus nécessaire car createInstallmentPlan 
     * retourne déjà le clientSecret pour le premier paiement
     * @param {string} installmentPlanId - ID du plan créé
     * @param {Object} paymentMethodData - Données de paiement
     */
    processFirstInstallment: async (installmentPlanId, paymentMethodData) => {
        try {
            console.log('🔄 Processing first installment for plan:', installmentPlanId);

            const response = await strapiClient.post('/api/payment/process-first-installment', {
                installmentPlanId,
                paymentMethodData,
                savePaymentMethod: true // Pour les paiements futurs
            });

            console.log('✅ First installment processed:', response.data);
            return response.data;

        } catch (error) {
            console.error('💥 Erreur traitement première mensualité:', error);
            throw new Error(
                error.response?.data?.error?.message || 
                'Erreur lors du traitement du paiement'
            );
        }
    },

    /**
     * Obtenir les détails d'un plan d'échelonnement
     * @param {string} installmentPlanId - ID du plan
     */
    getInstallmentPlan: async (installmentPlanId) => {
        try {
            console.log('🔍 Getting installment plan:', installmentPlanId);

            const response = await strapiClient.get(`/api/payment/installment-plan/${installmentPlanId}`);
            
            console.log('✅ Installment plan retrieved:', response.data);
            return response.data;

        } catch (error) {
            console.error('💥 Erreur récupération plan:', error);
            throw new Error(
                error.response?.data?.error?.message || 
                'Erreur lors de la récupération du plan'
            );
        }
    }
};